module.exports = __webpack_public_path__ + "static/lframe-kiwibank-wedding-loans-eee6288d247c059f72520bb215fe0e70.webp";